// modules/PageLoading.js
import React        from 'react';
import PageLoadingCirc from './images/PageLoadingCirc';

class PageLoading extends React.Component {
	render() {
		return (
			<div className="page-loading">{this.props.children} Loading<br/><br/><PageLoadingCirc /></div>
		);
	}
}

export default PageLoading;


/** WEBPACK FOOTER **
 ** ./src/modules/PageLoading.js
 **/